import React from 'react';
import cx from 'classnames';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import {ShowOnDesktopOnly} from '@wix/wixstores-client-common-components/dist/es/src/HOC/responsive/ShowOnDesktopOnly/ShowOnDesktopOnly';
import {ShowOnMobileOnly} from '@wix/wixstores-client-common-components/dist/es/src/HOC/responsive/ShowOnMobileOnly/ShowOnMobileOnly';
import {ProductPageSlotIds} from '../../../constants';
import {SPECS} from '../../../specs';
import styles from './ProductPageMediaSlot.scss';

export interface ProductPageMediaSlotProps {
  isMediaPluginInstalled: boolean;
  isStunning: boolean;
}

export const ProductPageMediaSlot: React.FC<ProductPageMediaSlotProps> = ({isMediaPluginInstalled, isStunning}) => {
  const {experiments} = useExperiments();
  const isBottomPositionForMobileSlot = experiments.enabled(SPECS.MediaSlotOnBottomForResponsiveGallery);
  const slotClassName = cx({
    [styles.mediaSlotInOverlay]: isMediaPluginInstalled,
    [styles.mediaSlotInOverlayStunning]: isMediaPluginInstalled && isStunning,
  });

  return (
    <>
      <ShowOnDesktopOnly>
        <div className={slotClassName}>
          <SlotsPlaceholder slotId={ProductPageSlotIds.ProductPageMedia1} />
        </div>
      </ShowOnDesktopOnly>
      {!isBottomPositionForMobileSlot && (
        <ShowOnMobileOnly>
          <div className={slotClassName}>
            <SlotsPlaceholder slotId={ProductPageSlotIds.ProductPageMedia1} />
          </div>
        </ShowOnMobileOnly>
      )}
    </>
  );
};
